import React from 'react';
import { styled } from "../../../stitches.config";
import dotmap from '../../../assets/img/natemat/career/dotmap.png';
import PersonLabel from './PersonLabel';


type PersonLabelTypes = {
    name: string,
    role: string,
    image: string,
    size: '96px' | '69px',
    location: {
        mobile: string[],
        desktop: string[],
    }
}

type ContactsProps = {
    isDesktop: boolean,
    children: JSX.Element,
}

const big = '96px';
const small = '69px';

const PersonLabels: PersonLabelTypes[] = [
    {
        name: 'Katarzyna Zuchowicz',
        role: 'Dziennikarka newsowa',
        image: 'https://m.natemat.pl/024b40c71f77dd501ca147c0981997a5,300,0,0,0.jpg',
        size: big,
        location: {
            mobile: ['20%', '40%'],
            desktop: ['60%', '5%']
        }
    },
    {
        name: 'Bartosz Godziński',
        role: "dziennikarz popkulturowy",
        image: 'https://m.natemat.pl/07ff0404c114202bc9030340c9604e5d,300,0,0,0.jpg',
        size: small,
        location: {
            mobile: ['5%', '10%'],
            desktop: ['65%', '60%']
        }
    },
    {
        name: 'Łukasz Grzegorczyk',
        role: 'Dziennikarz motoryzacyjny',
        image: 'https://m.natemat.pl/ff7937f6fd4dc459af710f4cd84fa4f9,780,0,0,0.webp',
        size: small,
        location: {
            mobile: ['0%', '70%'],
            desktop: ['40%', '5%']
        }
    },
    {
        name: 'Anna Dryjańska',
        role: 'Dziennikarka polityczna',
        image: 'https://m.natemat.pl/15389a8c076bc77bda58c7b17a1fee4c,375,375,1,0.jpg',
        size: big,
        location: {
            mobile: ['50%', '70%'],
            desktop: ['42%', '50%']
        }
    },
    {
        name: 'Daria Różańska',
        role: 'Reportażystka',
        image: 'https://m.natemat.pl/0debb71204cc1d2aad07a31324e6fce0,375,375,1,0.jpg',
        size: small,
        location: {
            mobile: ['70%', '50%'],
            desktop: ['20%', '50%']
        }
    },
    {
        name: 'Anna Kaczmarek',
        role: 'Dziennikarka zdrowotna',
        image: 'https://m.natemat.pl/b66135c0d40c4d546395e56fc57c537a,300,0,0,0.jpg',
        size: big,
        location: {
            mobile: ['50%', '15%'],
            desktop: ['15%', '5%']
        }
    },
]

const Contacts = ({ isDesktop, children }: ContactsProps) => {
    return (
        <JoinUs>
            <JoinUsWrapper>
                {children}
                <MapItems>
                    {
                        PersonLabels.map((item, index) => {
                            return (
                                <PersonLabel {...item} isDesktop={isDesktop} key={index} />
                            )
                        })
                    }
                </MapItems>
            </JoinUsWrapper>
            <OrangeCircle className="circle" />
        </JoinUs >
    )
}

export default Contacts;

const MapItems = styled('div', {
    width: '100%',
    height: '100%',
    position: 'relative',
    '@bp4': {
        width: '50%',
        height: '100%',
    }
})


const OrangeCircle = styled('div', {
    position: 'absolute',
    backgroundColor: '$natematPrimary',
    borderRadius: '50%',
    width: '150px',
    height: '150px',
    top: '50%',
    left: '50%',
    translate: '-50% -50%',
    filter: 'blur(200px)',
    '@bp4': {
        width: '200px',
        height: '200px',
        filter: 'blur(250px)',
    }
})


const JoinUs = styled('div', {
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    color: '$grayscale0Fixed',
    backgroundColor: '$grayscale100Fixed',
    backgroundPosition: 'top 10% center',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url("${dotmap}")`,
    backgroundSize: '150%',
    height: '700px',
    '.circle': {
        position: 'absolute',
        top: '50% !important',
        left: '70% !important',
        backgroundColor: '$natematPrimary',
        borderRadius: '50%',
        width: '150px',
        height: '150px',
        filter: 'blur(120px)',
        '@bp4': {
            width: '300px',
            height: '300px',
            filter: 'blur(250px)',
        }
    },
    '@bp4': {
        width: '100%',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        justifyContent: 'flex-start',

    }
})

const JoinUsWrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column-reverse',
    textAlign: 'left',
    height: '100%',
    padding: '40px 16px',
    '@bp4': {
        padding: '0px',
        paddingLeft: '84px',
        gap: '100px',
        height: '100%',
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
    }
})